import { FC } from 'react';

import { SearchParams } from '@/components/search/types';

import LoadingSpinner from '../../../../apps/mwd-v2/components/LoadingSpinner/LoadingSpinner';
import useSearchUtils from '../../utils/useSearchUtils';

import NothingToShow from './NothingToShow';

import style from './SearchStatus.module.css';

// Note for later: Update to search v2.

type SearchStatusProps = {
  isFetching: boolean;
  searchParams: SearchParams | null | undefined;
  noSearchResultFound: boolean | null;
  nothingToShow: boolean;
};
const SearchStatus: FC<SearchStatusProps> = ({ isFetching, searchParams, noSearchResultFound, nothingToShow }) => {
  const message = isFetching ? 'Bezig met zoeken' : 'Er zijn geen zoekresultaten';
  const { formatSearchModality, getClientNameFromSearchModality } = useSearchUtils();
  const clientName = getClientNameFromSearchModality(searchParams?.searchModality, searchParams?.searchType);
  return (
    <>
      {((isFetching && !noSearchResultFound) || noSearchResultFound) && (
        <div style={{ color: 'var(--tractie-color-content-default)' }} className={style.searchStatus}>
          {isFetching && <LoadingSpinner />}
          {searchParams ? (
            <>
              {message} voor {clientName} <strong>&#34;{formatSearchModality(searchParams)}&#34;</strong>
            </>
          ) : (
            message
          )}
        </div>
      )}
      {nothingToShow && !isFetching && <NothingToShow />}
    </>
  );
};
export default SearchStatus;
